import { createNavigation } from 'next-intl/navigation'
import { defineRouting } from 'next-intl/routing'
import type { ComponentProps } from 'react'
import { APP_DEFAULT_LOCALE, APP_LOCALES } from '@/lib/constants'
import { getOriginUrl } from '@/lib/general-helpers'

export const routing = defineRouting({
	// A list of all locales that are supported
	locales: APP_LOCALES,

	// Used when no locale matches
	defaultLocale: APP_DEFAULT_LOCALE,

	// do not include alternate links by default, as many pages may not have a counterpart for all locales
	// we will manage these with metadata
	alternateLinks: false,

	localeDetection: false,

	localePrefix: 'as-needed',
})

// https://next-intl-docs.vercel.app/docs/routing/navigation
export const { Link, redirect: _redirect, usePathname, useRouter } = createNavigation(routing)
export type LinkProps = ComponentProps<typeof Link>
// Help TypeScript detect unreachable code
// https://next-intl-docs.vercel.app/docs/routing/navigation#redirect
export const redirect: typeof _redirect = _redirect

export function isAppLink(link: string): boolean {
	try {
		const baseUrl = getOriginUrl()
		const url = new URL(link, baseUrl)
		return url.hostname === new URL(baseUrl).hostname
	} catch (_e) {
		return false
	}
}

export const isValueEqualToPathname = (value: string, pathname: string) =>
	value === pathname || `${value}/` === pathname
